import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import Tile from 'ol/layer/Tile';
import Attribution from 'ol/control/Attribution';
import Zoom from 'ol/control/Zoom';
import TileWMS from 'ol/source/TileWMS';
import Geolocation from 'ol/Geolocation';
import {fromLonLat} from 'ol/proj';
import BingMaps from 'ol/source/BingMaps';
import OSM from 'ol/source/OSM';
import Overlay from 'ol/Overlay';
import $ from 'jQuery';

global.baseLayersArray = [];
global.baseLayersArrayLength;
//var baseLayersArray = [];
//var topLayersArray = [];
//var baseLayersArrayLength;
//var topLayersArrayLength;

var attribution = new Attribution({collapsible: false});
var mapControls = [new Zoom({zoomInTipLabel: null, zoomOutTipLabel:null,zoomInLabel: '', zoomOutLabel:''}),attribution];
//var interactions = defaults({altShiftDragRotate:false, pinchRotate:false});

var container1 = document.getElementById('popup1');
var content1 = document.getElementById('popup-content');
var closer1 = document.getElementById('popup-closer');
var container2 = document.getElementById('popup2');
var content2 = document.getElementById('popup-content2');
var closer2 = document.getElementById('popup-closer2');
var container3 = document.getElementById('popup3');
var content3 = document.getElementById('popup-content3');
var closer3 = document.getElementById('popup-closer3');
var container4 = document.getElementById('popup4');
var content4 = document.getElementById('popup-content4');
var closer4 = document.getElementById('popup-closer4');

var overlay1 = new Overlay({
  element: container1
});
var overlay2 = new Overlay({
  element: container2
});
var overlay3 = new Overlay({
  element: container3
});
var overlay4 = new Overlay({
  element: container4
});

closer1.onclick = function() {
	hidePopup();
}
closer2.onclick = function() {
	hidePopup();
}
closer3.onclick = function() {
	hidePopup();
}
closer4.onclick = function() {
	hidePopup();
}

var key = 'Ah4C9Ite0bCpmz4Iu0MExgvuIfjpvEiQt06FTP_qBXjFptMM5WA9wPVp_WZfzfOr';
var extent = [1781111.8,8859142.8, 2003750.8,9349764.1];
var geoserverUrl = 'https://karta.sundsvall.se/geoserver/wms';
var geoserverUrl_test = 'https://kartatest.sundsvall.se/geoserver/wms';

var osm = new Tile({
  source: new OSM({attributions: '&copy; OpenStreetMap contributors'})
});

var topo = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:topowebbkartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_topo = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:topowebbkartan', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto1960 = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '1960 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:HistoriskaOrtofoton1960_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto1960 = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '1960 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:HistoriskaOrtofoton1960_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto1975 = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '1975 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:HistoriskaOrtofoton1975_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto1975 = new Tile({
  extent: extent,
  source: new TileWMS({
    attributions: '1975 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:HistoriskaOrtofoton1975_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2007 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2007 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2007_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2007 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2007 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2007_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2010 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2010 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2010_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2010 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2010 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2010_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2013 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2013 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2013_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2013 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2013 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2013_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2015 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2015 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2015_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2015 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2015 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2015_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2017 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2017 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2017_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2017 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2017 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2017_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2019 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2019 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2019_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2019 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2019 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2019_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2021 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2021 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2021_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2021 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2021 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2021_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var orto2023 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2021_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var ol_orto2023 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Orto2021_wms', 'VERSION': '1.1.1', 'TILED': true},
    serverType: 'geoserver',
    transition: 0
  })
});

var lmorto = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:Ortofoto50_25cm', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_lmorto = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '2023 flygfoto: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:Ortofoto50_25cm', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var lutning = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:terranglutning', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_lutning = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:terranglutning', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var skugg = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:terrangskuggning_wms', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_skugg = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Laserdata NH: &copy; Lantmäteriet Geodatasamverkan',
  	url: geoserverUrl,
	  params: {'LAYERS': 'Lantmateriet:terrangskuggning_wms', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var friluft = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Friluftskarta', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_friluft = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: {'LAYERS': 'Friluftskarta', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var detalj = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: {'LAYERS': 'SundsvallsKommun:detaljplan_mosaik', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var ol_detalj = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
	  url: geoserverUrl,
	  params: {'LAYERS': 'SundsvallsKommun:detaljplan_mosaik', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
	  transition: 0
  })
});

var hist1642 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1642', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1642 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1642', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1857 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1857', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1857 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1857', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1878 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1878', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1878 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1878', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1910 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1910', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1910 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1910', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1917 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1917', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1917 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1917', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1935 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1935', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1935 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1935', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1939 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1939', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1939 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1939', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var hist1952 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1952', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_hist1952 = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Sundsvalls kommun',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:HistoriskKarta1952', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ekonomiska = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:EkonomiskaKartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_ekonomiska = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:EkonomiskaKartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var general = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Generalstabskartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_general = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'Lantmateriet:Generalstabskartan', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var laga = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:LagaSkifteskartor_mosaik', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var ol_laga = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: 'Lantmäteriet Geodatasamverkan',
    url: geoserverUrl,
    params: {'LAYERS': 'SundsvallsKommun:LagaSkifteskartor_mosaik', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3014',
	  transition: 0
  })
});

var orientering = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Njurunda OK',
    url: geoserverUrl_test,
    params: {'LAYERS': 'SundsvallsKommun:OrienteringNjurunda', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3006',
	  transition: 0
  })
});

var ol_orientering = new TileLayer({
  extent: extent,
  source: new TileWMS({
    attributions: '&copy; Njurunda OK',
    url: geoserverUrl_test,
    params: {'LAYERS': 'SundsvallsKommun:OrienteringNjurunda', 'VERSION': '1.1.1', 'TILED': true},
	  serverType: 'geoserver',
    projection: 'EPSG:3006',
	  transition: 0
  })
});

baseLayersArray.push(topo);
baseLayersArray.push(friluft);
baseLayersArray.push(osm);
baseLayersArray.push(orto1960);
baseLayersArray.push(orto1975);
baseLayersArray.push(orto2007);
baseLayersArray.push(orto2010);
baseLayersArray.push(orto2013);
baseLayersArray.push(orto2015);
baseLayersArray.push(orto2017);
baseLayersArray.push(orto2019);
baseLayersArray.push(orto2021);
baseLayersArray.push(orto2023);
baseLayersArray.push(lmorto);
baseLayersArray.push(lutning);
baseLayersArray.push(skugg);
baseLayersArray.push(detalj);
baseLayersArray.push(hist1642);
baseLayersArray.push(hist1857);
baseLayersArray.push(hist1878);
baseLayersArray.push(hist1910);
baseLayersArray.push(hist1917);
baseLayersArray.push(hist1935);
baseLayersArray.push(hist1939);
baseLayersArray.push(hist1952);
baseLayersArray.push(ekonomiska);
baseLayersArray.push(general);
baseLayersArray.push(laga);
//baseLayersArray.push(orientering);

global.map1 = new Map({
  layers: [orto1960],
  target: 'map1',
  loadTilesWhileAnimating: true,
  loadTilesWhileInteracting: true,
  view: new View({
    center: fromLonLat([17.3, 62.4]),
    extent: extent,
    zoom: 13
  })
});

global.map2 = new Map({
  layers: [orto1975],
  target: 'map2',
  loadTilesWhileAnimating: true,
  loadTilesWhileInteracting: true,
  view: map1.getView()
});

global.map3 = new Map({
  layers: [orto2007],
  target: 'map3',
  loadTilesWhileAnimating: true,
  loadTilesWhileInteracting: true,
  view: map1.getView()
});

global.map4 = new Map({
  layers: [lmorto],
  target: 'map4',
  loadTilesWhileAnimating: true,
  loadTilesWhileInteracting: true,
  view: map1.getView()
});

map1.on('click', function(evt) {
  setPos(evt);
});

map2.on('click', function(evt) {
  setPos(evt);
});

map3.on('click', function(evt) {
  setPos(evt);
});

map4.on('click', function(evt) {
  setPos(evt);
});

var view = map1.getView();

var geolocation = new Geolocation({
	projection: view.getProjection()
});

geolocation.setTracking(true);

geolocation.on('change:position', function() {
	var coordinates = geolocation.getPosition();
  view.setCenter(coordinates);
  geolocation.setTracking(false);
});

function el(id) {
  return document.getElementById(id);
}

el('track').addEventListener('click', function() {
  geolocation.setTracking(true);
});

function changeMapLayer(index){
	var lager, layerArray;
	switch(index) {
		case 1:
			lager = document.getElementById('select1').value;
			layerArray = map1.getLayers();
			layerArray.pop();
			map1.addLayer(this[lager]);
			break;
		case 2:
			lager = document.getElementById('select2').value;
			layerArray = map2.getLayers();
			layerArray.pop();
			map2.addLayer(this[lager]);
			break;
		case 3:
			lager = document.getElementById('select3').value;
			layerArray = map3.getLayers();
			layerArray.pop();
			map3.addLayer(this[lager]);
			break;
		case 4:
			lager = document.getElementById('select4').value;
			layerArray = map4.getLayers();
			layerArray.pop();
			map4.addLayer(this[lager]);
			break;
	}
};


function hidePopup() {
	container1.style.display = 'none';
	container2.style.display = 'none';
	container3.style.display = 'none';
	container4.style.display = 'none';
	closer1.blur();
	closer2.blur();
	closer3.blur();
	closer4.blur();
	return false;
};

function setPos(evt){
	var coordinate = evt.coordinate;
	overlay1.setPosition(coordinate);
	overlay2.setPosition(coordinate);
	overlay3.setPosition(coordinate);
	overlay4.setPosition(coordinate);
	content1.innerHTML = '<code>SWEREF99 1330:<br />' + coordinate[1].toFixed(0) + ',' + coordinate[0].toFixed(0) + '</code>';
	container1.style.display = 'block';
	content2.innerHTML = '<code>SWEREF99 1330:<br />' + coordinate[1].toFixed(0) + ',' + coordinate[0].toFixed(0) + '</code>';
	container2.style.display = 'block';
	content3.innerHTML = '<code>SWEREF99 1330:<br />' + coordinate[1].toFixed(0) + ',' + coordinate[0].toFixed(0) + '</code>';
	container3.style.display = 'block';
	content4.innerHTML = '<code>SWEREF99 1330:<br />' + coordinate[1].toFixed(0) + ',' + coordinate[0].toFixed(0) + '</code>';
	container4.style.display = 'block';
}
